export const appEnv = {
    baseApiUrl: "/api",
    baseImgUrl: "clientApps/assets/images/inkAndtoner"
}